import api from '@/security/api'
import errorCatch from '@/helpers/errorCatch'

require('./../../security/interceptors')

const find = () => {
    return api.get('/users/profile')
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível carregar o perfil')
        })
}

const update = (data) => {
    return api.put(`/users/${data.id}`, data)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível atualizar o perfil')
        })
}

export default {
    find,
    update
}
